import React, { useContext, useState, useRef, useEffect } from 'react';

import { Link, useNavigate } from "react-router-dom";
import { TranslatorContext } from "../context/Translator";
import { SidebarContext } from "../context/Sidebar";
import sidenavs from "../assets/data/sidenavs.json";
import { useAuthStore } from "../store/auth.store.ts";


export default function SidebarLayout() {
    
    const { t, n, currentLanguage } = useContext(TranslatorContext);
    const { sidebar } = useContext(SidebarContext);
    const {  usuario } = useAuthStore((state) => state);

    const navigate = useNavigate(); // Hook para redirigir al usuario
    const setToken = useAuthStore((state) => state.setToken);
    const setUsuarioStore = useAuthStore((state) => state.setUsuario);
    
    const handleDropdown = (event) => {
        const buttonElement = event.currentTarget;
        const itemElement = buttonElement.parentElement;
        const isActive = itemElement.classList.contains('active');
        const allItems = document.querySelectorAll('.mc-sidebar-menu-item');
        const allDropdowns = document.querySelectorAll('.mc-sidebar-dropdown-list');
        const dropdownElement = itemElement.querySelector('.mc-sidebar-dropdown-list');

        if (isActive) {
            itemElement.classList.remove('active');
            dropdownElement.style.height = "0px";
        }
        else {
            allItems.forEach(item => item.classList.remove('active'));
            allDropdowns.forEach(dropdown => dropdown.style.height = "0px");
            
            itemElement.classList.add('active');
            dropdownElement.style.height = dropdownElement.scrollHeight + "px";
        }
    }

    const handleLogout = () => {
        // Limpiar el estado de autenticación
        setToken("");
        setUsuarioStore(null);

        // Redirigir al usuario a la página de inicio de sesión
        navigate("/login");
    };

    // Función auxiliar para verificar si el usuario tiene acceso según los roles
    const tieneAcceso = (roles, userRol) => {
        if (Array.isArray(roles)) {
            return roles.some(rol => userRol.includes(rol));
        }
        return userRol.includes(roles);
    };

    return (
        <aside as="aside" className={`mc-sidebar thin-scrolling ${ sidebar && "active"}`}>
            {sidenavs?.map((sidenav, sidenavIndex) => (
                 tieneAcceso(sidenav.rol, usuario.roles[0].codigo) && (
                <menu key={sidenavIndex}  className="mc-sidebar-menu">
                    <h5 className="mc-sidebar-menu-title">{t(sidenav.title)}</h5>
                    <ul className="mc-sidebar-menu-list">
                        {sidenav.menus.map((menu, menuIndex) => ( 
                             tieneAcceso(menu.rol, usuario.roles[0].codigo) && (
                            <li key={menuIndex} className='mc-sidebar-menu-item'>
                                {menu.submenus ?
                                    <>
                                        <button type="button" className="mc-sidebar-menu-btn" onClick={handleDropdown}>
                                            <i className="material-icons">{ menu.icon }</i>
                                            <span>{t(menu.text)}</span>
                                            { menu.badge?.text && <sup className={ menu.badge.variant }>{t(menu.badge.text)}</sup> }
                                            { menu.badge?.count && <sup className={ menu.badge.variant }>{n(menu.badge.count)}</sup> }
                                            { currentLanguage?.dir === "ltr" ? 
                                                <small className="material-icons right">chevron_right</small> 
                                                : <small className="material-icons left">chevron_left</small>
                                            }
                                        </button>

                                        <ul className='mc-sidebar-dropdown-list'>
                                            {menu.submenus.map((submenu, submenusIndex) => (
                                                <li key={submenusIndex} className="mc-sidebar-dropdown-item">
                                                    <Link to={submenu.path} className="mc-sidebar-dropdown-link">{t(submenu.text)}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                :
                                    <Link to={menu.path} className="mc-sidebar-menu-btn">
                                        <i className="material-icons">{ menu.icon }</i>
                                        <span>{t(menu.text)}</span>
                                        { menu.badge?.count && <sup className={ menu.badge.variant }>{n(menu.badge.count)}</sup> }
                                        { menu.badge?.text && <sup className={ menu.badge.variant }>{t(menu.badge.text)}</sup> }
                                    </Link>
                                }
                            </li>  
                             )
                        ))}
                    </ul>
                </menu> )

            ))}

            <div className="mc-sidebar-logout text-center">
            <button onClick={handleLogout} className="mc-btn primary sm">
                    <i className="material-icons">lock</i>
                    <span>Cerrar Sesión</span>
                </button>
            </div>
        </aside>
    )
}